class Results {

    constructor() {
        if (Results.instance) return Results.instance;
        this.container = document.querySelector('.location-results-container');

        if(this.container) {
            document.addEventListener('apiDataFetched', (data) => {
                // Run results a little later (always after the spinner)
                // FIXME: This can be improved by combining it with the API fetch call.
                setTimeout(() => {
                    this.showResults(data.detail);
                }, 250);
            });
            document.addEventListener('dropdownInputChange', () => {
                this.addLoadingSpinner();
            });
        }

        Results.instance = this;
    }

    addLoadingSpinner() {
        this.container.innerHTML = '<div id="loadingSpinner"><div></div></div>';
    }

    showResults(apiData) {
        this.container.innerHTML = '';

        const dataContainer = document.createElement('div');
        dataContainer.classList.add('results');

        if(apiData.length <= 0) {
            dataContainer.innerHTML = 'Keine Ergebnisse gefunden. Bitte ändern Sie die Suchparameter.';
            this.container.appendChild(dataContainer);
            return;
        }

        apiData.forEach((location) => {
            const services = location.services;

            services.forEach((service) => {
                const card = document.createElement('a');

                card.classList.add('service-card');
                card.href = service.url;

                /* eslint-disable indent */
                card.innerHTML = `
                    <div class="thumb">
                    ${service.thumbnail ?
                        `<img src="${service.thumbnail}" alt="${service.title}" />`
                        : '🥺 Kein Bild festgelegt'}
                    </div>
                    <div class="info">
                        ${service.audiences && service.audiences?.length > 0 ?
                            `<div class="audiences">
                                ${service.audiences.map(a => `<div class="btn audience">${a.titleShort ? a.titleShort : a.titleLong}</div>`).join('')}
                                </div>`
                        : ''}
                        <h3 class="title">
                            ${service.title + ' <span class="region">' + service.regions + '</span>'}
                        </h3>
                        <div class="excerpt">
                            ${service.excerpt}
                        </div>
                        ${service.highlights && service.highlights?.length > 0 ?
                            `<div class="highlights">
                                ${service.highlights.map(a => `<div class="btn highlight">${a}</div>`).join('')}
                            </div>`
                        : ''}
                    </div>`;
                /* eslint-enable indent */

                dataContainer.appendChild(card);
            });
        });

        this.container.appendChild(dataContainer);
    }
}

export default Results;
